import React, { Component } from 'react';
import { logError } from 'services/logger';
import Error from './components/Error';

interface ErrorBoundaryProps {
  children: any;
}

interface ErrorBoundaryState {
  error: Error | null;
  info: React.ErrorInfo | null;
}

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ error, info });
    logError(error, error.message, { info: info?.componentStack });
  }

  render() {
    if (this.state.error) return <Error error={this.state.error!} />;
    return this.props.children;
  }
}
